<ion-item>
  <ion-label>Dados Meteorológicos</ion-label>
  <ion-icon color="success" size="large" slot="end" name="add-circle" (click)="add()" />
  <ion-icon [name]="icone" size="small" slot="end" (click)="trocar()"/>
</ion-item>
<ion-list *ngIf="exibir">
  <ion-item-sliding *ngFor="let met of entidades">
    <ion-item (click)="edit(met)"  button detail="true">
      <ion-icon/>
      <ion-label><h3>{{met.tipo}}: {{met.valor}}</h3></ion-label>
    </ion-item>
    <ion-item-options>
      <ion-item-option>
        <ion-icon (click)="edit (met)" slot="icon-only" name="pencil-outline"></ion-icon>
      </ion-item-option>
      <ion-item-option color="danger">
        <ion-icon (click)="delete(met)" slot="icon-only" name="trash"></ion-icon>
      </ion-item-option>
    </ion-item-options>
  </ion-item-sliding>
</ion-list>


<ion-modal [isOpen]="isOpen">
  <ng-template>
    <ion-header>
      <ion-toolbar  color="success">
        <ion-buttons slot="start">
          <ion-button (click)="close()">
            <ion-icon name="arrow-back-outline"/>
          </ion-button>
        </ion-buttons>
        <ion-title>Meteorologia</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="save()">
            <ion-icon name="checkmark"/>
          </ion-button>
          <ion-button *ngIf="!novo" (click)="deleteSelected()" color="danger">
            <ion-icon name="trash"/>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-item>
        <ion-input   labelPlacement="floating" Label="Data/Hora" type="datetime-local" [(ngModel)]="item.dataHora" name=data />
      </ion-item>
      <ion-item>
        <ion-select interface="popover" [required]="true"  name="tipo" label-placement="floating" label="Tipo"
                    [(ngModel)]="item.tipo">
          <ion-select-option *ngFor="let fu of tiposMeteorologias" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item>
        <ion-input [required]="true" [(ngModel)]="item.valor" inputmode="decimal" name="valor"
                   label-placement="floating" label="Valor" type="number"/>

      </ion-item>
    </ion-content>
  </ng-template>
</ion-modal>
